var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.082,
    height: 10.034,
    viewBox: "0 0 16.082 10.034",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#45338c;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1045.226,1048.876a.9.9,0,0,0-.858.354,5.729,5.729,0,0,1-1.114.656,4.563,4.563,0,0,0-1.4.938c-.242.307-.769.39-1.169.571a3.67,3.67,0,0,0-.628.282,9.143,9.143,0,0,1-2.609,1.086.927.927,0,0,1-.747-.183,3.673,3.673,0,0,1-.728-.922.889.889,0,0,1-.128-1,3.023,3.023,0,0,0,.106-1.213c.019-.44.023-.881.034-1.322a.249.249,0,0,1,.014-.087c.108-.264,1.02-.532,1.3-.492.569.081.645.645.994.935.112.093.016.42.042.636.06.49.179.561.621.339.464-.232.918-.485,1.364-.75a7.638,7.638,0,0,1,1.472-.9c1.286-.4,2.207-1.393,3.4-1.937a6.661,6.661,0,0,0,.979-.717,1.347,1.347,0,0,1,.43-.218,4.484,4.484,0,0,0,1.819-.942,1.7,1.7,0,0,1,.415-.164,7.76,7.76,0,0,0,.883-.417,8.059,8.059,0,0,1,.84-.6,1.566,1.566,0,0,1,.774-.011c.329.043.348.3.3.562a.075.075,0,0,0,0,.044c.648,1.126-.562,1.232-.981,1.766a3.838,3.838,0,0,1-.578.51,1.427,1.427,0,0,1-.25.18c-.534.278-1.083.53-1.6.83-.543.312-1.057.675-1.592,1a7.849,7.849,0,0,0-.826.464A4.388,4.388,0,0,0-1045.226,1048.876Z",
    transform: "translate(1054.716 -1042.752)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick10);
export default __webpack_public_path__ + "static/media/tick-10.33426dcb9a96de923669a1ddb6320751.svg";
export { ForwardRef as ReactComponent };